import * as React from 'react';
import { Pressable, View } from 'react-native';

import { Text } from '@/components/ui/text';
import { SetupLayout } from '@/features/setup/components/setup-layout';
import { useSetupContext } from '@/features/setup/setup-provider';
import { useAuth } from '@/hooks/use-auth';
import { getProfileShareUrl } from '@/utils/share-urls';
import { shareProfileLink } from './share-profile-link';

const STEP = 5;

export function FriendSeedingScreen() {
  const { advance, goBack, isAdvancing, skipFriendSeeding } = useSetupContext();
  const { user } = useAuth();
  const shareUrl = getProfileShareUrl(user?.username ?? '');

  const handleShare = React.useCallback(() => {
    void shareProfileLink(shareUrl);
  }, [shareUrl]);

  // Skipping is a recorded choice, not just a different way to move on: the
  // payload distinguishes "shared" from "declined to share".
  const handleSkip = React.useCallback(() => {
    skipFriendSeeding();
    void advance();
  }, [advance, skipFriendSeeding]);

  return (
    <SetupLayout
      step={STEP}
      onBack={goBack}
      primaryLabel="Continue"
      onPrimary={advance}
      primaryLoading={isAdvancing}
      secondaryLabel="Skip for now"
      onSecondary={handleSkip}
    >
      <Text className="mb-2 text-xl font-bold text-foreground">Invite Friends</Text>
      <Text className="mb-6 text-sm text-muted-foreground">
        Flavrly is better with friends. Share your profile link so they can find you.
      </Text>

      <View className="w-full items-center rounded-xl bg-surface-secondary p-6">
        <Text className="mb-2 text-sm text-muted-foreground">Your profile link</Text>
        <Text className="mb-4 font-mono text-sm text-foreground" numberOfLines={1}>
          {shareUrl}
        </Text>

        <Pressable
          onPress={handleShare}
          accessibilityRole="button"
          accessibilityLabel="Share Link"
          className="rounded-lg bg-primary px-6 py-2"
        >
          <Text className="text-sm font-semibold text-primary-foreground">Share Link</Text>
        </Pressable>
      </View>
    </SetupLayout>
  );
}
